import { loader } from 'graphql.macro'

export default async function editCommentOnTicket ({ dataLoaders, variables }) {
  const schema = loader('./editCommentOnTicket.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      comment: variables.comment,
      commentId: variables.commentId
    }
  })

  return response.editCommentOnTicket
}
